
import { ServiceUtil } from './services.util'
import { userService } from "../_services"

export const registrationService = {
  getUserHash,
  sendVerificationCode,
    verifyCode,
    CreateProfile, 
    sendConfirmMobileOptIn,
    CreateProfileByLeadId,
    getExistingCustomerRegistration
};

function getUserHash(userHashRequest) {

    const requestOptions = ServiceUtil.putRequest(userHashRequest);
    return window.fetch("/Utilities/CalculateUserHash", requestOptions)
        .then(ServiceUtil.handleResponse)
        .then(data => {
            return data;
        });
}

function sendVerificationCode(MfaRequest) {
    
  return ServiceUtil.executeServiceCall("AccountAPI", "mfa/SendMfaCode", 
    ServiceUtil.postRequest(MfaRequest));

}

function sendConfirmMobileOptIn(tokenId, email, optIn ){
  const data = {
    MfaTokenId : tokenId, 
    UserEmailAddress : email, 
    MobileOptIn : optIn, 
    ProfileType : 8
  }
    return ServiceUtil.executeServiceCall("ProfileAPI", "api/Profile/SaveMobileOptInSignUp/", ServiceUtil.postRequest(data));
}

function verifyCode(mfaAuthenticationRequest) {
  return ServiceUtil.executeServiceCall("AccountAPI", "mfa/ValidateMfaCodeForUnregistered", 
    ServiceUtil.postRequest(mfaAuthenticationRequest));

}

function CreateProfile(profile) {

    if (!profile.selectedLanguage) {
        profile.selectedLanguage = userService.getUserLanguage();
    }
    
    return ServiceUtil.executeServiceCall("ProfileAPI", "api/Profile/CreateProfile", ServiceUtil.postRequest(profile));
}

function CreateProfileByLeadId(profile) {

    if (!profile.selectedLanguage) {
        profile.selectedLanguage = userService.getUserLanguage();
    }

    return ServiceUtil.executeServiceCall("ProfileAPI", "api/Profile/CreateProfileByLeadId", ServiceUtil.postRequest(profile));
}

function getExistingCustomerRegistration(userHash) {
    return ServiceUtil.executeServiceCall("ProfileAPI", "api/Profile/GetExistingCustomerRegistration",
        ServiceUtil.postRequest(userHash));
}





// WEBPACK FOOTER //
// ./src/_services/registration.service.js